var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8028_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33276 16.2473V3.74937C3.33276 3.19693 3.55222 2.66711 3.94286 2.27648C4.33349 1.88584 4.86331 1.66638 5.41575 1.66638H15.8307C16.0517 1.66638 16.2636 1.75416 16.4199 1.91042C16.5761 2.06667 16.6639 2.2786 16.6639 2.49958V17.4971C16.6639 17.7181 16.5761 17.93 16.4199 18.0863C16.2636 18.2425 16.0517 18.3303 15.8307 18.3303H5.41575C4.86331 18.3303 4.33349 18.1108 3.94286 17.7202C3.55222 17.3296 3.33276 16.7998 3.33276 16.2473ZM3.33276 16.2473C3.33276 15.6949 3.55222 15.165 3.94286 14.7744C4.33349 14.3838 4.86331 14.1643 5.41575 14.1643H16.6639",
    stroke: "white",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8028_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9967,
    height: 19.9967,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/help_center.636a8ca07bd5b1fa677050d1c2d354cb.svg";
export { ForwardRef as ReactComponent };